module.exports = __webpack_public_path__ + "be8825c06df3a12b6839d28a44a3ab22.MP3";